export default __webpack_public_path__ + "static/tr-c5e9ee6c774f41263d09fae82b0916ad.svg";